<template>
    <b-row class="align-items-center mb-4">
        <b-col sm="6" md="4">
            <b-form-group label="Categoría">
                <el-select v-model="localCategory" placeholder="Seleccione la categoría" @change="emitFilters">
                    <el-option v-for="category in categories" :key="category.id" :label="category.name"
                        :value="category.id" />
                </el-select>
            </b-form-group>
        </b-col>
        <b-col v-if="fields && fields.length > 0" sm="6" md="2" class="d-flex justify-content-start mt-2">
            <template v-if="validarPermisoComponente(permissionEdit)">
                <b-button variant="primary" @click="$emit('open-modal')">
                    <i class="fa fa-plus"></i> Crear
                </b-button>
            </template>
        </b-col>
        <b-col v-else sm="12" md="12" class="d-flex justify-content-start mt-2">
            <b-alert show variant="warning" class="w-100 d-flex align-items-center"
                style="border-left: 4px solid #ffc107; background-color: #fffbe6; color: #856404;">
                <i class="fa fa-exclamation-circle mr-2" style="font-size: 1.2rem;"></i>
                <span>No hay un formulario asociado a esta categoría.</span>
            </b-alert>
        </b-col>
    </b-row>
</template>

<script>
import { validarPermisoComponente } from "@/plugins/acl";
export default {
    name: "Filters",
    props: {
        categories: {
            type: Array,
            required: true,
        },
        fields: {
            type: Array,
            required: true,
        },
        permissionEdit: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            localCategory: this.selectedCategory,
            validarPermisoComponente: validarPermisoComponente,
        };
    },
    watch: {
        categories: {
            handler(newCategories) {
                if (newCategories.length > 0 && !this.localCategory) {
                    this.localCategory = newCategories[0].id;
                    this.emitFilters();
                }
            },
            immediate: true,
        },
    },
    methods: {
        emitFilters() {
            this.$emit("update-filters", {
                category_id: this.localCategory,
            });
        },
    },
};
</script>
